import React, { useState } from 'react'
import { useRecoilState } from 'recoil'
import { useLocation } from 'react-router-dom'
import { globalStream } from 'src/atom/GlobalStream'
import { useNavigate } from 'react-router-dom'
import LogoHeader from 'src/components/header/LogoHeader'

const RegistrationValidation = () => {
  const [GSteam, setGlobalSteam] = useRecoilState(globalStream)
  const [isChecked, setIsChecked] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const details = location.state?.det || {}

  const handleCheckChange = (e) => {
    setIsChecked(e.target.checked)
  }

  const handleSubmit = () => {
    // Hide the buttons before printing
    const buttons = document.querySelectorAll('.btn')
    buttons.forEach((button) => {
      button.style.display = 'none'
    })

    // Trigger the print dialog
    window.print()

    // Show the buttons again after printing
    buttons.forEach((button) => {
      button.style.display = 'block'
    })
  }
  const handleFileSubmit = () => {
    navigate('/login')
  }

  return (
    <>
      <div className="container-fluid" style={{ padding: '10px 20px' }}>
        <LogoHeader />
        <div
          className="mt-2 d-flex justify-content-center align-items-center"
          style={{
            fontWeight: 'bold',
            fontSize: '25px',
            textAlign: 'center',
          }}
        >
          Thank You for Registering Online for Admission to{' '}
          {GSteam?.counsellingName === 'PG'
            ? 'MD/MS (Ayurveda)'
            : 'BAMS/BHMS'}{' '}
          Courses 2026-27
        </div>

        <div className="card ms-5 me-5 mt-3">
          <div className="card-body">
            <div className="row">
              <div className="col-12 d-flex justify-content-strt">
                <th>Your Login Credentials </th>
              </div>
            </div>
            <hr />
            <div className="mt-2">
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <td>Full Name of Applicant :</td>
                    <td className="col-6">
                      <input
                        type="text"
                        className={`form-control  ? 'is-invalid' : ''}`}
                        id="name"
                        placeholder="Name of applicant"
                        name="name"
                        value={details?.name}
                      //   onChange={handleInputChange}
                      />
                    </td>
                  </div>
                  <div className="col-6">
                    <td>Father Name :</td>
                    <td className="col-6">
                      <input
                        type="text"
                        className={`form-control  ? 'is-invalid' : ''}`}
                        id="fatherName"
                        placeholder="Father Name of applicant "
                        name="fatherName"
                        value={details?.fatherName}
                      //   onChange={handleInputChange}
                      />
                    </td>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <td>Mother Name :</td>
                    <td className="col-6">
                      <input
                        type="text"
                        className={`form-control  ? 'is-invalid' : ''}`}
                        id="motherName"
                        placeholder="Mother Name"
                        name="motherName"
                        value={details?.motherName}
                      //   onChange={handleInputChange}
                      />
                    </td>
                  </div>
                  <div className="col-6">
                    <td>Date of Birth :</td>
                    <td className="col-6">
                      <input
                        type="text"
                        className={`form-control  ? 'is-invalid' : ''}`}
                        id="dob"
                        placeholder="Date of birth"
                        name="dob"
                        value={details?.dob}
                      //   onChange={handleInputChange}
                      />
                    </td>
                  </div>
                </div>
                <hr />
                <div className=" d-flex flex-column align-items-left">
                  <label>
                    <th>Your Login Details</th>
                  </label>
                </div>
                <hr />
              </div>
            </div>
            <div className="mt-2">
              <div className="col-md-12">
                <div className="row justify-content-center">
                  <div className="col-md-4 d-flex align-items-center">
                    <label htmlFor="UserId" className="me-2 col-md-2">
                      User Id
                    </label>
                    <input
                      type="text"
                      className="form-control ms-4"
                      id="UserId"
                      value={details?.userId}
                    />
                  </div>
                </div>

                <hr />
                <div
                  className="d-flex flex-column align-items-left"
                  style={{
                    color: 'red',
                    lineHeight: '1.6',
                  }}
                >
                  <p>
                    Your User ID and Password have been sent to your registered email
                    address and mobile number. Please retain your User ID and Password
                    for all future communication and correspondence related to your
                    application.
                  </p>

                  <p>
                    Please note that you will not be able to register again using the
                    same NEET Roll Number.
                  </p>

                  <ul>
                    <li>
                      After successfully logging in with your User ID and Password,
                      you will be required to change your password. Changing the
                      password is mandatory.
                    </li>

                    <li>
                      Please keep your User ID and Password confidential and do not
                      share them with any unauthorized person.
                    </li>

                    <li>
                      It is not mandatory, but candidates are advised to take a
                      printout of this page for their records and future reference.
                    </li>
                  </ul>
                </div>

                <hr />

                <div className="text-center form-group d-flex justify-content-left">
                  <button
                    type="submit"
                    className="btn btn-sm text-white btn-info mx-2 mt-3 me-3"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Print'}
                  </button>

                  <button
                    type="submit"
                    className="btn btn-sm text-white btn-info mx-2 mt-3"
                    onClick={handleFileSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Proceed to Login'}
                  </button>
                </div>
                <div
                  style={{
                    color: 'red',
                    marginTop: '10px',
                    lineHeight: '1.5',
                  }}
                >
                  <strong>Disclaimer:</strong> Shri Krishna Ayush University,
                  Kurukshetra shall not be responsible for any misuse of your User ID
                  and Password. Candidates are advised to keep their login credentials
                  confidential.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
               @media print {
                .btn {
                  display: none !important;
                }
              }
                `}
      </style>
    </>
  )
}

export default RegistrationValidation
